import update from 'immutability-helper';
import typeToReducer from 'type-to-reducer';
import { utenteInitialState } from './initialState';

export default typeToReducer({
  CAMBIA_UFFICIO: (state, action) => update(state, {
    ufficioSelezionato: { $set: action.ufficio },
  }),
  ATTIVA_TOUR_730: (state, action) => update(state, {
    tour730Attivo: { $set: true },
  }),
  DISATTIVA_TOUR_730: (state, action) => update(state, {
    tour730Attivo: { $set: false },
  }),
  ATTIVA_TOUR_RICHIESTEENTI: (state, action) => update(state, {
    tourRichiesteEntiAttivo: { $set: true },
  }),
  DISATTIVA_TOUR_RICHIESTEENTI: (state, action) => update(state, {
    tourRichiesteEntiAttivo: { $set: false },
  }),
  ATTIVA_TOUR_IMU: (state, action) => update(state, {
    tourImuAttivo: { $set: true },
  }),
  DISATTIVA_TOUR_IMU: (state, action) => update(state, {
    tourImuAttivo: { $set: false },
  }),
}, utenteInitialState);
